'use client';
import React from 'react';
import { Service } from './Service';
import httpCodes from '@/constants/httpCodes';
import { ErrorType } from '@/ui/features/authentication/components/errorAlert';

export function useController(
  setToggle: React.Dispatch<React.SetStateAction<boolean>>,
) {
  const [loading, setLoading] = React.useState(false);
  const [apiError, setApiError] = React.useState(ErrorType.NONE);

  const handlePasswordRecover = async (payload: { email: string }) => {
    setLoading(true);
    try {
      const response = await Service.recoverPassword(payload);
      setLoading(false);

      if (response.status === httpCodes.SUCCESS) {
        setToggle(true);
      } else {
        setApiError(ErrorType.UNEXPECTED);
      }
    } catch (error) {
      setApiError(ErrorType.UNEXPECTED);
      setLoading(false);
    }
  };

  return {
    loading,
    apiError,
    handlePasswordRecover,
  };
}
